/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_OrderedInputs */

const en_scene_guestlist_ordered = /** @type {(inputs: Scene_Guestlist_OrderedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordered`)
};

/**
* | output |
* | --- |
* | "Ordered" |
*
* @param {Scene_Guestlist_OrderedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_ordered = /** @type {((inputs?: Scene_Guestlist_OrderedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_OrderedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_ordered(inputs)
});